import { z } from 'zod';
/**
 * Schema for Bible location with validation rules.
 * All indices are 0-based.
 */
export const BibleLocationSchema = z.object({
    testamentIndex: z.number().int().nonnegative(), // 0 = OT, 1 = NT
    bookIndex: z.number().int().nonnegative(), // Index within testament
    chapterIndex: z.number().int().nonnegative(), // 0-based chapter
    verseIndex: z.number().int().nonnegative(), // 0-based verse
    wordIndex: z.number().int().nonnegative().optional(), // Optional word position
});
/**
 * Convert BibleLocation to a canonical string identifier.
 * Format: "T-B-C-V" or "T-B-C-V-W" if wordIndex present
 */
export function locationToId(location) {
    const base = `${location.testamentIndex}-${location.bookIndex}-${location.chapterIndex}-${location.verseIndex}`;
    return location.wordIndex !== undefined ? `${base}-${location.wordIndex}` : base;
}
/**
 * Parse a canonical location ID back to BibleLocation.
 */
export function idToLocation(id) {
    const parts = id.split('-').map(Number);
    if (parts.length < 4 || parts.some(isNaN)) {
        throw new Error(`Invalid location ID: ${id}`);
    }
    return {
        testamentIndex: parts[0],
        bookIndex: parts[1],
        chapterIndex: parts[2],
        verseIndex: parts[3],
        ...(parts[4] !== undefined && { wordIndex: parts[4] }),
    };
}
/**
 * Compare two Bible locations.
 * Returns negative if a < b, positive if a > b, 0 if equal.
 */
export function compareLocations(a, b) {
    if (a.testamentIndex !== b.testamentIndex)
        return a.testamentIndex - b.testamentIndex;
    if (a.bookIndex !== b.bookIndex)
        return a.bookIndex - b.bookIndex;
    if (a.chapterIndex !== b.chapterIndex)
        return a.chapterIndex - b.chapterIndex;
    if (a.verseIndex !== b.verseIndex)
        return a.verseIndex - b.verseIndex;
    return (a.wordIndex ?? 0) - (b.wordIndex ?? 0);
}
//# sourceMappingURL=bible-location.js.map